export default "__VITE_ASSET__62ac86bc__"